export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
    }

    showAddAccountButton() {
        return this.$state.is('company.user-directories.manage-user.details');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/manage-user.controller.js